module.exports = __webpack_public_path__ + "img/bar-chart.c04be7c.svg";